export default __webpack_public_path__ + "static/media/auth-backgroundx2.bd3746b5.webp";